import { FC, useState } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { DuoGiftIcon } from '../theme/Icons';
import { NavigationItem } from '../navigation/NavigationItem';
import { ReferralInviteModal } from './ReferralInviteModal';

interface IInviteFriendsButtonProps {
    closeMenu?: () => void;
}

export const InviteFriendsButton: FC<IInviteFriendsButtonProps> = ({ closeMenu }) => {
    const mixpanel = useInstance(MixPanelEventEmitter);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClick = () => {
        mixpanel.track('Referral Initiated');
        if (closeMenu) {
            closeMenu();
        }
        setTimeout(() => {
            setIsModalOpen(true);
        }, 350);
    };

    return (
        <>
            <NavigationItem
                label="Invite Friends"
                data-id="invite-friends-button"
                icon={<DuoGiftIcon />}
                onClick={handleClick}
            />
            <ReferralInviteModal
                isOpen={isModalOpen}
                closeHandler={() => setIsModalOpen(false)}
            />
        </>
    );
};
